'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

const kpis = [
  {
    id: 'kpi-pv',
    label: 'Personal Volume',
    value: '2,847',
    unit: 'PV',
    change: '+12.4%',
    changeDir: 'up',
    sub: 'vs last month',
    icon: 'ChartBarIcon',
    color: 'text-primary',
    bg: 'bg-primary/8',
    hero: true,
  },
  {
    id: 'kpi-tv',
    label: 'Team Volume',
    value: '18,340',
    unit: 'TV',
    change: '+8.1%',
    changeDir: 'up',
    sub: 'vs last month',
    icon: 'UserGroupIcon',
    color: 'text-violet-600',
    bg: 'bg-violet-50 dark:bg-violet-950/30',
    hero: false,
  },
  {
    id: 'kpi-commission',
    label: 'Commission Balance',
    value: '$1,284',
    unit: '',
    change: '+$340',
    changeDir: 'up',
    sub: 'this month',
    icon: 'BanknotesIcon',
    color: 'text-emerald-600',
    bg: 'bg-emerald-50 dark:bg-emerald-950/30',
    hero: false,
  },
  {
    id: 'kpi-pending',
    label: 'Pending Earnings',
    value: '$428',
    unit: '',
    change: '3 orders',
    changeDir: 'neutral',
    sub: 'awaiting confirmation',
    icon: 'ClockIcon',
    color: 'text-amber-600',
    bg: 'bg-amber-50 dark:bg-amber-950/30',
    hero: false,
    alert: true,
  },
  {
    id: 'kpi-visitors',
    label: 'Store Visitors',
    value: '1,042',
    unit: '',
    change: '-4.2%',
    changeDir: 'down',
    sub: 'this week',
    icon: 'EyeIcon',
    color: 'text-blue-600',
    bg: 'bg-blue-50 dark:bg-blue-950/30',
    hero: false,
    alert: true,
  },
  {
    id: 'kpi-customers',
    label: 'Active Customers',
    value: '127',
    unit: '',
    change: '+5',
    changeDir: 'up',
    sub: 'new this month',
    icon: 'UsersIcon',
    color: 'text-rose-500',
    bg: 'bg-rose-50 dark:bg-rose-950/30',
    hero: false,
  },
  {
    id: 'kpi-referrals',
    label: 'Active Referrals',
    value: '18',
    unit: '',
    change: '+2',
    changeDir: 'up',
    sub: 'team members',
    icon: 'UserPlusIcon',
    color: 'text-teal-600',
    bg: 'bg-teal-50 dark:bg-teal-950/30',
    hero: false,
  },
];

export default function DashboardKPIs() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-7 gap-4">
      {/* Hero KPI */}
      {kpis.filter(k => k.hero).map(kpi => (
        <div
          key={kpi.id}
          className="sm:col-span-2 lg:col-span-2 2xl:col-span-2 card-elevated rounded-xl p-6 relative overflow-hidden"
        >
          <div className="blob-gold absolute -top-8 -right-8 w-40 h-40" />
          <div className="relative z-10">
            <div className="flex items-center justify-between mb-4">
              <div className={`w-11 h-11 rounded-xl ${kpi.bg} flex items-center justify-center`}>
                <Icon name={kpi.icon as any} size={20} className={kpi.color} />
              </div>
              <span className={`richesse-badge text-[10px] ${
                kpi.changeDir === 'up' ? 'bg-success-bg text-success' :
                kpi.changeDir === 'down'? 'bg-danger-bg text-danger' : 'bg-muted text-muted-foreground'
              }`}>
                {kpi.changeDir === 'up' ? '↑' : kpi.changeDir === 'down' ? '↓' : '→'} {kpi.change}
              </span>
            </div>
            <p className="text-3xl font-bold text-foreground tabular-nums mb-1">
              {kpi.value} <span className="text-lg text-primary">{kpi.unit}</span>
            </p>
            <p className="text-sm font-semibold text-foreground mb-0.5">{kpi.label}</p>
            <p className="text-xs text-muted-foreground">{kpi.sub}</p>
          </div>
        </div>
      ))}

      {/* Regular KPIs */}
      {kpis.filter(k => !k.hero).map(kpi => (
        <div
          key={kpi.id}
          className={`card-elevated rounded-xl p-5 ${kpi.alert ? 'border-warning/30 bg-warning-bg/10' : ''}`}
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-9 h-9 rounded-lg ${kpi.bg} flex items-center justify-center`}>
              <Icon name={kpi.icon as any} size={16} className={kpi.color} />
            </div>
            {kpi.alert && (
              <Icon name="ExclamationTriangleIcon" size={14} className="text-warning" />
            )}
          </div>
          <p className="text-xl font-bold text-foreground tabular-nums mb-0.5">{kpi.value}</p>
          <p className="text-xs font-semibold text-foreground mb-1">{kpi.label}</p>
          <div className="flex items-center gap-1.5">
            <span className={`text-[10px] font-semibold ${
              kpi.changeDir === 'up' ? 'text-success' :
              kpi.changeDir === 'down'? 'text-danger' : 'text-muted-foreground'
            }`}>
              {kpi.changeDir === 'up' ? '↑' : kpi.changeDir === 'down' ? '↓' : ''} {kpi.change}
            </span>
            <span className="text-[10px] text-muted-foreground">{kpi.sub}</span>
          </div>
        </div>
      ))}
    </div>
  );
}